class Dropdown {
    expandedClass = 'ui-dropdown-button--expanded';

    constructor() {
        this.onOutsideClick = this.onOutsideClick.bind(this);
        document.querySelectorAll('.ui-dropdown-button').forEach(el => el.addEventListener('click', this.onButtonClick.bind(this)));
    }

    static init() {
        new Dropdown();
    }

    onButtonClick(e) {
        e.preventDefault();
        const el = e.currentTarget;

        this.closeAll(el);
        this.unbindOutsideClick();

        const isExpanded = el.classList.contains(this.expandedClass);
        el.classList.toggle(this.expandedClass, !isExpanded);
        el.closest('.ui-dropdown').querySelector('.ui-dropdown-menu').classList.toggle('hidden', isExpanded);

        if (!isExpanded) {
            this.bindOutsideClick();
        }
    }

    closeAll(except = null) {
        document.querySelectorAll(`.${this.expandedClass}`).forEach((el) => {
            if (el === except) {
                return;
            }

            el.classList.remove(this.expandedClass);
            el.closest('.ui-dropdown').querySelector('.ui-dropdown-menu').classList.add('hidden');
        });
    }

    bindOutsideClick() {
        document.body.addEventListener('click', this.onOutsideClick);
    }

    unbindOutsideClick() {
        document.body.removeEventListener('click', this.onOutsideClick);
    }

    onOutsideClick(e) {
        if (e.target.closest('.ui-dropdown')) {
            let el;

            if (e.target.classList.contains('ui-dropdown-menu__item')) {
                el = e.target;
            } else {
                el = e.target.closest('.ui-dropdown-menu__item');
            }

            // Attr data-dropdown-close="false" prevent a menu to be closed
            if (!el || el.dataset.dropdownClose === 'false') {
                return;
            }
        }

        this.closeAll(null);
        this.unbindOutsideClick();
    }
}

const dropdown = new Dropdown;

export default dropdown;